import React from 'react';
import { WhyChoose } from '../components/home/WhyChoose';

export function WhyChoosePage() {
  return <WhyChoose />;
}
